import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom"
import GetStrLocalized from '../datas/GetStrLocalized';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import BigButtonWithTextAtBottom from "../components/bigButton/BigButtonWithTextAtBottom"
import H2Title from '../components/title/H2Title'
import { VerseToDisplayProps } from "../props/versetodisplayprops";
import { createErrorModalContent } from '../props/ModalContentProps'
import ReadingContent from '../components/util/ReadingContent'
import H1Title from '../components/title/H1Title'
import { HcContext, SizeOfWindow } from '../types/hccontext'



// =========================================================================
// == COMPOSANT 1: LE CARROUSEL DE BANNIÈRE (INCHANGÉ)
// =========================================================================
interface BannerCarouselJPProps {
  language: string;
  hcContext: HcContext;
}

const BannerCarouselJP: React.FC<BannerCarouselJPProps> = ({ language, hcContext }) => {
  // ... (Tout le code du BannerCarousel reste exactement le même qu'avant)
  // ... (Il gère lui-même sa largeur de 100%)
  const banners = [
    {
      img: 'https://assets.radiorcf.com/styles/890x500/assets/2025-08/hq720.jpg.webp',
      verse: '“Je suis la lumière du monde.” – Jean 8, 12',
    },
    {
      img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9T7XDtEC-0VO_PmIiuJQgVh7YndHUEtSG9w&s',
      verse: '“Si vous aviez de la foi comme un grain de moutarde…” – Matthieu 17, 20',
    },
    {
      img: '/jesus_regarde_au_loin.png',
      verse: '“Heureux les artisans de paix.” – Matthieu 5, 9',
    },
  ];

  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  const nextSlide = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % banners.length);
  };

  const prevSlide = () => {
    setDirection(-1);
    setIndex((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const slideVariants = {
    enter: (dir: number) => ({ x: dir > 0 ? '100%' : '-100%', zIndex: 1 }),
    center: { zIndex: 1, x: '0%' },
    exit: (dir: number) => ({ zIndex: 0, x: dir > 0 ? '-100%' : '100%' }),
  };

  const slideTransition = {
    x: { type: "tween", duration: 0.7, ease: "easeInOut" },
  };

  const textCenteringStyles: React.CSSProperties = {
    position: 'absolute', inset: '0px', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', textAlign: 'center',
    color: 'white', paddingLeft: '1rem', paddingRight: '1rem',
  };

  const titleStyles: React.CSSProperties = {
    fontSize: '3.75rem', fontWeight: 800,
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
  };

  const verseStyles: React.CSSProperties = {
    marginTop: '2rem', fontStyle: 'italic', fontSize: '1.5rem',
    maxWidth: '42rem', color: 'rgba(255, 255, 255, 0.9)',
  };

  return (
    <div
      style={{
        width: '100%', height: '600px', overflow: 'hidden', 
        position: 'relative', backgroundColor: '#000',
        // J'ai enlevé le 'borderRadius' qui pouvait aussi créer des coins blancs
      }}
    >
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={index} custom={direction} variants={slideVariants} 
          initial="enter" animate="center" exit="exit"
          transition={slideTransition} 
          style={{ position: 'absolute', width: '100%', height: '100%', opacity: 1 }}
        >
          <img
            src={banners[index].img}
            style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <div style={{ position: 'absolute', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.4)', zIndex: 1 }} />
          <div style={{ ...textCenteringStyles, zIndex: 2 }}> 
            <H1Title>
              <span style={{ ...titleStyles, visibility: 'hidden' }}>Dieu nous parle</span>
            </H1Title>
            <p style={verseStyles}>{banners[index].verse}</p>
          </div>
        </motion.div>
      </AnimatePresence>

      <div style={{ ...textCenteringStyles, zIndex: 5, pointerEvents: 'none' }}>
        <H1Title>
          <span style={titleStyles}>Dieu nous parle</span>
        </H1Title>
        <p style={{ ...verseStyles, visibility: 'hidden' }}>“Placeholder”</p>
      </div>
      
      <div
        style={{
          position: 'absolute', top: '1.5rem', left: '1.5rem', zIndex: 5, 
          color: 'white', fontSize: '1.25rem', fontWeight: 600,
          textShadow: '1px 1px 3px rgba(0,0,0,0.6)', pointerEvents: 'none',
        }}
      >
        Issy c'est Jeunes Pros
      </div>

      <button onClick={prevSlide} style={{
          position: 'absolute', left: '1.5rem', top: '50%', transform: 'translateY(-50%)', 
          backgroundColor: 'rgba(0, 0, 0, 0.4)', color: 'white', padding: '0.75rem',
          borderRadius: '9999px', zIndex: 8, border: 'none', cursor: 'pointer'
        }}>
        <ChevronLeft size={36} />
      </button>

      <button onClick={nextSlide} style={{
          position: 'absolute', right: '1.5rem', top: '50%', transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.4)', color: 'white', padding: '0.75rem',
          borderRadius: '9999px', zIndex: 8, border: 'none', cursor: 'pointer'
        }}>
        <ChevronRight size={36} />
      </button>
    </div>
  );
};


interface ThisIsForYoungProfessionalsProps {
  language: string;
  hcContext: HcContext;
  backendUrl: string;
  setDocumentTitle: React.Dispatch<React.SetStateAction<string>>;
}

interface AReadingProps {
    title: string;
    subTitle: string;
    referenceUrl: string;
    reference: string;
    content: VerseToDisplayProps[];
}


interface ExternalLink {
	title: string;
	url: string;
}

interface MassProps {
	name: string;
	readings: AReadingProps[];
}

interface RequestProps {
	title: string;
	externalLinks: ExternalLink[];
	masses: MassProps[];
}

// Le composant Page
const ThisIsForYoungProfessionals: React.FC<ThisIsForYoungProfessionalsProps> = ({
  language,
  hcContext,
  backendUrl,
  setDocumentTitle,
}) => {

  useEffect(() => {
    setDocumentTitle("Issy c'est Jeunes Pros");
  }, [setDocumentTitle, language]);

    const location = useLocation()
    const [lastPath, setLastPath] = useState("");
    const [request, setRequest] = useState<RequestProps>({ title: "", externalLinks: [], masses: [] });
    const [typeOfReadingsFolder, setTypeOfReadingsFolder] = useState("");

    if (location.pathname !== lastPath) {
        setLastPath(location.pathname);
        const foldersArray = location.pathname.split('/');
        if (foldersArray.length > 2)
            setTypeOfReadingsFolder(foldersArray[2]);
        let dateFolder = ""
        if (foldersArray.length > 3)
            dateFolder = foldersArray[3];
        fetch(backendUrl + "/readings_of_the_day_content_json?l=" + language + "&r=gospel&d=" + dateFolder)
            .then(res => res.json())
            .then(jsonData => {
                if (jsonData.errorMessage) {
                    hcContext.setError(createErrorModalContent(language, jsonData.errorMessage))
                    return
                }
                setRequest(jsonData);
            })
            .catch(rejected => {
                hcContext.setError(createErrorModalContent(language, rejected.message))
            });
    }


  return (
    // Conteneur principal de la page SANS PADDING
    <div style={{ fontFamily: 'sans-serif' }}>
      
      <BannerCarouselJP language={language} hcContext={hcContext} />

      <br/>
      <br/>
      <H2Title isDarkTheme={hcContext.isDarkTheme}>Catégories</H2Title>
      <div className='hc-categories-left-margin'>
            <BigButtonWithTextAtBottom link="joie" image="/buttons/old_testament.jpg" duration="" title="Joie" tags="" beginOfClassName="hc-big-button-normal" hcContext={hcContext} />
            <BigButtonWithTextAtBottom link="tristesse" image="/buttons/psalms.jpg" duration="" title="Tristesse" tags="" beginOfClassName="hc-big-button-normal" hcContext={hcContext} />
            <BigButtonWithTextAtBottom link="souffrance" image="/buttons/new_testament.jpg" duration="" title="Souffrance" tags="" beginOfClassName="hc-big-button-normal" hcContext={hcContext} />
      </div>

      <br/>
			{
				request &&
				request.masses.length > 0 &&
				<>
					{
						request.masses.map((mass, massIndex) => {

							return (
								<div key={"mass-" + massIndex}>
									{
										mass &&
										mass.readings.length > 0 &&
										<React.Fragment>
											{
												mass.readings.map((reading, readingIndex) => {
													return (
														<React.Fragment key={"reading-" + massIndex + "-" + readingIndex}>
                              <H2Title isDarkTheme={hcContext.isDarkTheme}><span dangerouslySetInnerHTML={{ __html: reading.title }}></span></H2Title>
															<br />
															<div style={{ marginLeft: 40 }}>
																<div className='hc-content-text' style={{ paddingLeft: '15px' }}>
																	
																	<br />
																	<a href={reading.referenceUrl}>{reading.reference}</a>
																	<br />
																	<span dangerouslySetInnerHTML={{ __html: reading.subTitle }}></span>
																</div>
																<br /><br />
																<ReadingContent language={language} type="bible" content={reading.content} allowToDisplayLinkFromCorpus={hcContext.userAsRightsToModifyTheContent} hcContext={hcContext} />
															</div>
															<br />
														</React.Fragment>
													)
												})
											}
										</React.Fragment>
									}
								</div>
							)

						})
					}
				</>
			}

    </div>
  );
};

export default ThisIsForYoungProfessionals;